import React, { useEffect } from "react";
import useProduct from "./useProduct";
// import { API } from "../../../config";
import useCategory from "../category/useCategory";

function CreateProductComponent({ onHandleCancel, editingProduct }) {
  const { categories } = useCategory();

  const {
    mainImagePreview,
    selectedImages,
    err,
    formDataRef,
    values,
    onChangeHandler,
    removeMainImage,
    removeImage,
    onClickHandler,
    isUpdatingProduct,
    isCreatingProduct,
  } = useProduct(editingProduct, onHandleCancel);
  const { description, name, price, category, shipping, quantity, sold } =
    values;

  return (
    <form className="mb-3" onSubmit={onClickHandler}>
      <h3>Upload Cover Image</h3>
      <div encType="multipart/form-data">
        <label className="btn btn-secondary">
          <input
            type="file"
            accept="image/*"
            name="photo"
            multiple
            onChange={onChangeHandler("photo")}
            style={{ overflow: "hidden" }}
          />
        </label>
      </div>

      {mainImagePreview && (
        <div
          className="image-preview"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          <div
            style={{
              position: "relative",
              margin: "5px",
              width: "100px",
              height: "100px",
            }}
          >
            <img
              src={mainImagePreview}
              alt={`preview main image`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              loading="lazy"
              onError={(e) => {
                // console.log("Main image failed to load:", mainImagePreview);
                e.target.style.display = "none";
              }}
            />
            <button
              type="button"
              onClick={() => {
                removeMainImage();
              }}
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            >
              X
            </button>
          </div>
        </div>
      )}

      <br />
      <h3>Upload Extra Images</h3>
      <div>
        <label className="btn btn-secondary">
          <input
            type="file"
            accept="image/*"
            name="photo"
            multiple
            disabled={err}
            onChange={onChangeHandler("photos")}
          />
        </label>
      </div>
      <div
        className="image-preview"
        style={{ display: "flex", flexWrap: "wrap" }}
      >
        {selectedImages.map((preview, index) => (
          <div
            key={index}
            style={{
              position: "relative",
              margin: "5px",
              width: "100px",
              height: "100px",
            }}
          >
            <img
              src={preview}
              alt={`preview ${index}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
              loading="lazy"
              onError={(e) => {
                // console.log("Selected image failed to load:", preview);
                e.target.style.display = "none";
              }}
            />
            <button
              type="button"
              onClick={() => removeImage(index)}
              style={{
                position: "absolute",
                top: "0",
                right: "0",
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                cursor: "pointer",
              }}
            >
              X
            </button>
          </div>
        ))}
      </div>

      {selectedImages?.length > 0 && (
        <div>
          <strong>
            {selectedImages?.length} Image
            {selectedImages?.length !== 1 ? "s" : ""} Selected
          </strong>
        </div>
      )}
      {err && (
        <p
          style={{
            color: "red",
            fontSize: "0.75rem",
          }}
        >
          maximum length images 4
        </p>
      )}
      <div className="form-group">
        <label className="text-muted ">Name</label>
        <input
          type="text"
          className="form-control"
          value={name}
          onChange={onChangeHandler("name")}
        ></input>
      </div>
      <br></br>
      <div className="form-group">
        <label className="text-muted ">Description</label>
        <textarea
          type="textarea"
          className="form-control"
          value={description}
          onChange={onChangeHandler("description")}
        ></textarea>
      </div>
      <br></br>
      <div className="form-group">
        <label className="text-muted ">Price</label>
        <input
          type="number"
          className="form-control"
          value={price}
          onChange={onChangeHandler("price")}
        ></input>
      </div>
      <br></br>
      <div className="form-group">
        <label className="text-muted ">Category</label>
        <select
          className="form-control"
          value={category || ""}
          onChange={onChangeHandler("category")}
        >
          <option value="">Please select the category</option>
          {categories?.length > 0 &&
            categories?.map((c, i) => {
              return (
                <option key={i} value={c._id}>
                  {c.name}
                </option>
              );
            })}
        </select>
      </div>
      <br></br>
      <div className="form-group">
        <label className="text-muted ">Shipping</label>
        <select
          className="form-control"
          // value={shipping ? "1" : shipping === "0" ? "0" : ""}
          value={shipping === "1" ? "1" : shipping === "0" ? "0" : ""}
          onChange={onChangeHandler("shipping")}
        >
          <option value="">Please select the shipping</option>
          <option value="0">No</option>
          <option value="1">Yes</option>
        </select>
      </div>
      <br></br>
      <div className="form-group">
        <label className="text-muted ">Quantity</label>
        <input
          type="Number"
          className="form-control"
          value={quantity}
          onChange={onChangeHandler("quantity")}
        ></input>
      </div>
      <br></br>
      {/* <div className="form-group">
        <label className="text-muted ">Sold</label>
        <input
          type="Number"
          className="form-control"
          value={sold}
          onChange={onChangeHandler("sold")}
        ></input>
      </div> */}
      <br></br>
      <div className="form-group">
        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={isUpdatingProduct || isCreatingProduct}
            className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isUpdatingProduct
              ? "Updating..."
              : editingProduct
              ? "Update Product"
              : isCreatingProduct
              ? "Creating..."
              : "Create Product"}
          </button>
          <button
            type="button"
            onClick={onHandleCancel}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-400 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
}

export default CreateProductComponent;
